module.exports = __webpack_public_path__ + "static/media/range_2_orange.de562dcb.png";